import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';

import { ConstantCostsService } from '../../services/constant-costs.service';

@Component({
  selector: 'app-update-constant-costs',
  templateUrl: './update-constant-costs.component.html',
  styleUrls: ['./update-constant-costs.component.css']
})
export class UpdateConstantCostsComponent implements OnInit {
  costId: string;
  cost: any;
  constantCostForm: FormGroup;
  costSubscription: Subscription;

  constructor(
    private constantCostsService: ConstantCostsService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute
  ) {
    this.costId = this.activatedRoute.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.createForm();
    this.costSubscription = this.constantCostsService.getConstantCost(this.costId).subscribe(data => {
      this.cost = data;
      this.constantCostForm.get('folio').setValue(data.folio);
      this.constantCostForm.get('description').setValue(data.description);
      this.constantCostForm.get('value').setValue(data.value);
      this.costSubscription.unsubscribe();
    });
  }

  createForm(){
    this.constantCostForm = this.fb.group({
      folio: ['', Validators.required],
      description: ['', Validators.required],
      value: ['', Validators.required]
    });
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    this.constantCostsService.updateConstantCost(this.costId, value);
  }


}
